(function () {
var host = document.querySelector('[data-wgm-host]');
if (!host) return;
var cfg = JSON.parse(host.getAttribute('data-wgm-config') || '{}');
var navSel = cfg.nav || '.thb-full-menu > li';
var openDelay = typeof cfg.delay === 'number' ? cfg.delay : 120;
var closeDelay = 180;
var items = document.querySelectorAll(navSel);
if (!items.length) return;
var caret = document.querySelector(navSel + '.menu-item-has-children > a svg, ' + navSel + '.menu-item-has-children > a img');
function key(s) {
return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
}
var panels = {};
var all = host.querySelectorAll('[data-wgm-panel]');
for (var i = 0; i < all.length; i++) {
panels[key(all[i].getAttribute('data-wgm-panel'))] = all[i];
}
var header = document.querySelector('theme-header, #header, .header') || null;
var openPanel = null, openLi = null, openTimer, closeTimer;
// The school rows are printed once, in the mobile drawer, so the same ~58
// links are not shipped twice on every page. The desktop grid is empty in
// the HTML and gets a copy of those rows the first time any panel opens.
// The originals stay in the drawer; this only ever clones them.
var schoolGrid = host.querySelector('.wgm-schoolgrid');
var schoolsCloned = false;
function cloneSchools() {
if (schoolsCloned || !schoolGrid) return;
schoolsCloned = true;
var src = document.querySelectorAll('[data-wgd-schoollist] .wgm-group');
if (!src.length) return;
var frag = document.createDocumentFragment();
for (var i = 0; i < src.length; i++) frag.appendChild(src[i].cloneNode(true));
// The drawer's filter hides rows with an inline display, so drop any of
// that from the copy and the grid matches what Liquid used to print.
var hidden = frag.querySelectorAll('.wgd-row, [data-wgd-group]');
for (var j = 0; j < hidden.length; j++) hidden[j].style.display = '';
schoolGrid.appendChild(frag);
}
function anchorBottom() {
var b = header ? header.getBoundingClientRect().bottom : 0;
var below = document.querySelectorAll(cfg.anchor || '[id*="__announcement-bar"]');
for (var i = 0; i < below.length; i++) {
var r = below[i].getBoundingClientRect();
if (r.height && r.bottom > b && r.top <= b + 4) b = r.bottom;
}
return b;
}
function place(p) {
var top = anchorBottom();
if (top < 0) top = 0;
p.style.top = Math.round(top) + 'px';
var foot = p.querySelector('.wgm-foot');
var extra = foot ? foot.offsetHeight : 0;
p.style.setProperty('--wgm-max', Math.max(200, window.innerHeight - top - extra - 24) + 'px');
}
function close() {
clearTimeout(openTimer);
if (!openPanel) return;
openPanel.removeAttribute('data-open');
if (openLi) {
openLi.removeAttribute('data-wgm-active');
var a = openLi.querySelector('a');
if (a) a.setAttribute('aria-expanded', 'false');
}
openPanel = null;
openLi = null;
}
function open(li, p) {
clearTimeout(closeTimer);
if (openPanel === p) return;
close();
cloneSchools();
p.setAttribute('data-open', '');
place(p);
li.setAttribute('data-wgm-active', '');
var a = li.querySelector('a');
if (a) a.setAttribute('aria-expanded', 'true');
openPanel = p;
openLi = li;
}
var bound = 0;
for (var n = 0; n < items.length; n++) {
(function (li) {
var link = li.querySelector('a');
if (!link) return;
var p = panels[key(link.textContent)];
if (!p) return;
bound++;
var old = li.querySelectorAll(':scope > ul, :scope > .sub-menu, :scope > .mega-menu, :scope > div');
for (var k = 0; k < old.length; k++) old[k].style.display = 'none';
li.classList.add('wgm-trigger', 'menu-item-has-children');
if (caret && !link.querySelector('svg, img')) {
link.appendChild(caret.cloneNode(true));
}
link.setAttribute('aria-expanded', 'false');
link.setAttribute('aria-haspopup', 'true');
li.addEventListener('mouseenter', function () {
clearTimeout(closeTimer);
clearTimeout(openTimer);
openTimer = setTimeout(function () { open(li, p); }, openDelay);
});
li.addEventListener('mouseleave', function () {
clearTimeout(openTimer);
closeTimer = setTimeout(close, closeDelay);
});
p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
p.addEventListener('mouseleave', function () {
closeTimer = setTimeout(close, closeDelay);
});
link.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') {
if (openPanel === p) return;
e.preventDefault();
open(li, p);
return;
}
if (e.key === 'Tab' && !e.shiftKey && openPanel === p) {
var first = p.querySelector('a[href],button,input');
if (first) { e.preventDefault(); first.focus(); }
}
});
p.addEventListener('keydown', function (e) {
if (e.key !== 'Tab' || e.shiftKey) return;
var f = p.querySelectorAll('a[href],button,input');
if (!f.length || document.activeElement !== f[f.length - 1]) return;
e.preventDefault();
var next = li.nextElementSibling && li.nextElementSibling.querySelector('a');
close();
if (next) next.focus(); else link.focus();
});
})(items[n]);
}
if (!bound) return;
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && openPanel) {
var a = openLi && openLi.querySelector('a');
close();
if (a) a.focus();
}
});
document.addEventListener('focusin', function (e) {
if (!openPanel) return;
if (openPanel.contains(e.target)) return;
if (openLi && openLi.contains(e.target)) return;
close();
});
window.addEventListener('scroll', function () {
if (openPanel) place(openPanel);
}, { passive: true });
window.addEventListener('resize', function () {
if (openPanel) place(openPanel);
});
})();
